module.exports = __webpack_public_path__ + "img/ftth_index02.fc0d21ff.jpg";